export default __webpack_public_path__ + "static/media/background.6cf492b5.jpg";